import React from 'react';
import CreateCountryForm from './CreateCountryForm';
import { useParams } from 'react-router-dom';

const CountryManagement = () => {
  const params = useParams();
  const countryCode = params?.id;

  return (
    <div className="page-content p-4">
      <CreateCountryForm countryCode={countryCode} />
    </div>
  );
};

export default CountryManagement;
